import { signal } from '@preact/signals-react';

import type { ResponseStatus } from 'API/common/types';

export const reportWidgetsIDsSignal = signal<string[]>([]);

export const reportWidgetsLoadingSignal = signal<{ [widgetID: string]: boolean }>({});

export const reportWidgetsErrorSignal = signal<{ [widgetID: string]: ResponseStatus }>({});

export const reportIsHiddenSignal = signal(true);
